import styled from 'styled-components';

import { media } from '../../styles/media';

export const Root = styled.dl`
  display: flex;
  flex-direction: row;
  align-items: baseline;
`;

export const Title = styled.dt`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 25px;
  height: 25px;

  margin-right: ${props => props.theme.layout.gutter / 4}px;

  border-radius: 50%;
  border: 1px solid ${props => props.theme.color.white};

  > i {
    font-size: 1.2rem;
  }

  ${media.tablet`
    width: 35px;
    height: 35px;

    margin-right: ${props => props.theme.layout.gutter / 2}px;

    > i {
      font-size: 1.5rem;
    }
  `};
`;

export const Content = styled.dd`
  font-size: 1.5rem;
  letter-spacing: 0.4px;
  line-height: 23.5px;

  ${media.tablet`
    font-size: 1.8rem;
    letter-spacing: 0.5px;
    line-height: 29px;
  `};
`;
